import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { BairroService } from '../services/bairro.service';
import { MunicipioService } from '../services/municipio.service';
import { UfService } from '../services/uf.service';
import { PostoService } from '../services/posto.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-posto-edit',
	templateUrl: './posto-edit.component.html',
	styleUrls: ['./posto-edit.component.css'],
	animations: [loadingFade]

})
export class PostoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public posto_id = null;

	public formPosto: FormGroup;

	public uf_array = [];
	public municipio_array = [];
	public bairro_array = [];

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private bairroSvc: BairroService,
		private municipioSvc: MunicipioService,
		private postoSvc: PostoService,
		private ufSvc: UfService) { }

	ngOnInit() {
		this.pegaUf();
		this.criaForm();

		this.route.params.subscribe(params => {
			if (params.id) {
				this.posto_id = params.id;
				// pega dados a partir do id
				this.postoSvc.getposto(params.id).then((data: any) => {

					this.pegaMunicipios(data);
					this.pegaBairros(data);

					this.preencheForm({
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: '',
						cliente_id: '',
						posto_id: data.posto_id,
						posto_nome: data.posto_nome,
						posto_cnpj: data.posto_cnpj,
						posto_endereco: data.posto_endereco,
						posto_cep: data.posto_cep,
						posto_endereco_numero: data.posto_endereco_numero,
						uf_id: data.uf_id,
						municipio_id: data.municipio_id,
						bairro_id: data.bairro_id
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formPosto = this.fb.group({
			posto_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			posto_nome: ['', [Validators.required]],
			posto_cnpj: ['', [Validators.required]],
			posto_endereco: ['', [Validators.required]],
			posto_cep: ['', [Validators.required]],
			posto_endereco_numero: ['', [Validators.required]],
			uf_id: [null, [Validators.required]],
			municipio_id: [null, [Validators.required]],
			bairro_id: [null, [Validators.required]]
		});
	}

	preencheForm(dados) {
		this.formPosto.setValue(dados);
	}

	onChangeUf(uf_id) {
		this.formPosto.controls.municipio_id.setValue(null);
		this.formPosto.controls.bairro_id.setValue(null);
		this.bairro_array = [];
		this.pegaMunicipios(uf_id);
	}

	onChangeMunicipio(municipio_id) {
		this.formPosto.controls.bairro_id.setValue(null);
		this.pegaBairros(municipio_id);
	}

	pegaMunicipios(e) {
		this.municipioSvc.getMunicipioByUf(e.uf_id).then((data: any[]) => {
			this.municipio_array = data;
		});
	}

	pegaBairros(e) {
		this.bairroSvc.getBairroByMunicipio(e.municipio_id).then((data: any[]) => {
			this.bairro_array = data;
		});
	}

	pegaUf() {
		this.ufSvc.getUfs().then((data: any[]) => {
			this.uf_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	enviaPosto() {
		if (this.formPosto.valid) {
			this.submitting = true;

			let toSend = this.formPosto.value;

			if (this.posto_id === null) { // criar
				this.postoSvc.criaPosto(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Posto cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/postos']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.postoSvc.editaPosto(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Posto cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/postos']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formPosto.controls) {
				let campo = this.formPosto.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formPosto.get(nome);
		return input.touched && input.invalid;
	}
}
